import React from 'react';
import PropTypes from 'prop-types';
import Reveal from 'react-reveal/Reveal';
import Responsive from 'react-responsive';
import VideoCoverFallback from 'react-video-cover';
import './VideoRowCustomizable.scss';


const propTypes = {
    posterDesktop: PropTypes.string,
    posterMobile: PropTypes.string,
    videoSrcDesktop: PropTypes.string,
    videoSrcMobile: PropTypes.string,
    textBoxPosition: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.object,
    ctaroute: PropTypes.string,
    ctalabel: PropTypes.string,
    textBoxWidth: PropTypes.number,
    screenWidth: PropTypes.number,
    LeftPositionMargin: PropTypes.number,
    RightPositionMargin: PropTypes.number,
    LeftPositionHotZoneMargin: PropTypes.number,
    RightPositionHotZoneMargin: PropTypes.number,
    lableWidth: PropTypes.number,
};


export default class VideoRowCustomizable extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.addEventListener('load', this.handleLoad);

    }

    render() {

        const Desktop = props => <Responsive {...props} minWidth={1200} />;
        const DesktopSm = props => <Responsive {...props} minWidth={1025} maxWidth={1199} />;
        const TableLg = props => <Responsive {...props} minWidth={921} maxWidth={1024} />;
        const TableMd = props => <Responsive {...props} minWidth={841} maxWidth={920} />;
        const TableSm = props => <Responsive {...props} minWidth={770} maxWidth={840} />;
        const MobileLg = props => <Responsive {...props} minWidth={641} maxWidth={769} />;
        const MobileMd = props => <Responsive {...props} minWidth={416} maxWidth={640} />;
        const MobileSm = props => <Responsive {...props} minWidth={321} maxWidth={415} />;
        const MobileXsm = props => <Responsive {...props} maxWidth={320} />;

        let isSafari = window.safari !== undefined;

        const {posterDesktop, posterMobile, videoSrcDesktop, videoSrcMobile, textBoxPosition, label, title, content, ctaroute, ctalabel, textBoxWidth, screenWidth, LeftPositionHotZoneMargin, RightPositionHotZoneMargin, LeftPositionMargin, RightPositionMargin, lableWidth} = this.props;

        const videoOptionsDesktop = {
            style: {
                position: 'relative'
            },
            poster: posterDesktop,
            src: videoSrcDesktop,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsSmall = {
            style: {
                width: '100%',
                height: '562px',
                objectFit: 'cover',
            },
            poster: posterDesktop,
            src: videoSrcDesktop,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsTlg = {
            style: {
                width: '100%',
                maxHeight: '650px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };
        const videoOptionsTmd = {
            style: {
                width: '100%',
                maxHeight: '595px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };
        const videoOptionsTsm = {
            style: {
                width: '100%',
                maxHeight: '540px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsMlg = {
            style: {
                width: '100%',
                maxHeight: '500px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsMmd = {
            style: {
                width: '100%',
                height: '463px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsMsm = {
            style: {
                width: '100%',
                height: '355px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsMxsm = {
            style: {
                width: '100%',
                height: '282px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };


        const cta = (
            <a className='media-row-fb-cta' href={ctaroute}>{ctalabel} </a>
        );

        const LeftPositionBoxStyle = {
            width: `${textBoxWidth}px`,
            marginLeft: `${LeftPositionMargin}%`,
            marginRight: `${100 - Math.ceil((LeftPositionHotZoneMargin+20)/screenWidth*100)}%`,
        };

        //console.log('overlay left', LeftPositionBoxStyle);


        const RightPositionBoxStyle = {
            width: `${textBoxWidth}px`,
            marginLeft: `${100 - Math.ceil((RightPositionHotZoneMargin+20)/screenWidth*100)}%`,
            marginRight: `${RightPositionMargin}%`,
        };

        const MobileLableStyle = {
            maxWidth: `${lableWidth}px`,
        };
        //console.log('overlay right', RightPositionBoxStyle);


        const boxWidth = Math.floor(textBoxWidth/screenWidth*100);
        const leftHotZoneP = 100 - Math.ceil((LeftPositionHotZoneMargin+20)/screenWidth*100);
        const rightHotZoneP = 100 - Math.ceil((RightPositionHotZoneMargin+20)/screenWidth*100);

        if(LeftPositionMargin + boxWidth + leftHotZoneP > 100) {
            console.log('Error, left box overlap!');
        }
        if(RightPositionMargin + boxWidth + rightHotZoneP > 100) {
            console.log('Error, right box overlap!');
        }

        let left = textBoxPosition === 'left';
        let right = textBoxPosition === 'right';

        return(
            <div>
                <Desktop>
                    <div className={`full-bleed-vid-container`}>
                        <div className='vid--holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsDesktop}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                            {left &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy left`} style={LeftPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label mt5 ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                            {right &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy right`} style={RightPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label mt5 ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                        </div>
                    </div>
                </Desktop>
                <DesktopSm >
                    <div className={`full-bleed-vid-container`}>
                        <div className='vid--holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsSmall}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                            {left &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy left`} style={LeftPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label mt5 ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                            {right &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy right`} style={RightPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label mt5 ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                        </div>
                    </div>
                </DesktopSm>
                <TableLg>
                    <div className={`full-bleed-vid-container-mobile`}>
                        <div className='video__holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsTlg}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                        </div>
                        <div className="full-bleed-copy-mobile">
                            <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                            <div className="full-bleed-hrdiv"></div>
                            <h2 className="full-bleed-label " style={MobileLableStyle}>{label}</h2>
                            {content}
                            <div className='cta-holder'>
                                {ctaroute && cta}
                            </div>
                        </div>
                    </div>
                </TableLg>
                <TableMd>
                    <div className={`full-bleed-vid-container-mobile`}>
                        <div className='video__holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsTmd}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                        </div>
                        <div className="full-bleed-copy-mobile">
                            <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                            <div className="full-bleed-hrdiv"></div>
                            <h2 className="full-bleed-label " style={MobileLableStyle}>{label}</h2>
                            {content}
                            <div className='cta-holder'>
                                {ctaroute && cta}
                            </div>
                        </div>
                    </div>
                </TableMd>
                <TableSm>
                    <div className={`full-bleed-vid-container-mobile`}>
                        <div className='video__holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsTsm}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                        </div>
                        <div className="full-bleed-copy-mobile">
                            <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                            <div className="full-bleed-hrdiv"></div>
                            <h2 className="full-bleed-label " style={MobileLableStyle}>{label}</h2>
                            {content}
                            <div className='cta-holder'>
                                {ctaroute && cta}
                            </div>
                        </div>
                    </div>
                </TableSm>
                <MobileLg>
                    <div className={`full-bleed-vid-container-mobile`}>
                        <div className='video__holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsMlg}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                        </div>
                        <div className="full-bleed-copy-mobile">
                            <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                            <div className="full-bleed-hrdiv"></div>
                            <h2 className="full-bleed-label " style={MobileLableStyle}>{label}</h2>
                            {content}
                            <div className='cta-holder'>
                                {ctaroute && cta}
                            </div>
                        </div>
                    </div>
                </MobileLg>
                <MobileMd>
                    <div className={`full-bleed-vid-container-mobile`}>
                        <div className='video__holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsMmd}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                        </div>
                        <div className="full-bleed-copy-mobile">
                            <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                            <div className="full-bleed-hrdiv"></div>
                            <h2 className="full-bleed-label " style={MobileLableStyle}>{label}</h2>
                            {content}
                            <div className='cta-holder'>
                                {ctaroute && cta}
                            </div>
                        </div>
                    </div>
                </MobileMd>
                <MobileSm>
                    <div className={`full-bleed-vid-container-mobile`}>
                        <div className='video__holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsMsm}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                        </div>
                        <div className="full-bleed-copy-mobile">
                            <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                            <div className="full-bleed-hrdiv"></div>
                            <h2 className="full-bleed-label " style={MobileLableStyle}>{label}</h2>
                            {content}
                            <div className='cta-holder'>
                                {ctaroute && cta}
                            </div>
                        </div>
                    </div>
                </MobileSm>
                <MobileXsm>
                    <div className={`full-bleed-vid-container-mobile`}>
                        <div className='video__holder'>
                            <VideoCoverFallback className="vid-base"
                                                videoOptions={videoOptionsMxsm}
                                                remeasureOnWindowResize
                                                getResizeNotifier={resizeNotifier => {
                                                    this.setState({
                                                        resizeNotifier,
                                                    });
                                                }}
                            />
                        </div>
                        <div className="full-bleed-copy-mobile">
                            <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                            <div className="full-bleed-hrdiv"></div>
                            <h2 className="full-bleed-label " style={MobileLableStyle}>{label}</h2>
                            {content}
                            <div className='cta-holder'>
                                {ctaroute && cta}
                            </div>
                        </div>
                    </div>
                </MobileXsm>

            </div>
        );
    }
}


VideoRowCustomizable.propTypes = propTypes;

VideoRowCustomizable.defaultProps ={
    textBoxPosition: 'middle',
    posterDesktop: null,
    posterMobile: null,
    videoSrcDesktop: null,
    videoSrcMobile: null,
    title: null,
    content: null,
    label: null,
    ctaroute: null,
    ctalabel: null
};



// WEBPACK FOOTER //
// ./src/components/VideoRowCustomizable/index.js